import { c as _c } from "react/compiler-runtime";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import type { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import { useXtdhCollectionsQuery } from "@/hooks/useXtdhCollectionsQuery";
import { useMemo } from "react";
export default function UserPageCollectedFiltersNetworkCollection(t0) {
  const $ = _c(9);
  const {
    identity,
    selected,
    setSelected
  } = t0;
  let t1;
  if ($[0] !== identity) {
    t1 = {
      identity,
      pageSize: 100,
      sortField: "xtdh",
      order: "DESC"
    };
    $[0] = identity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    collections
  } = useXtdhCollectionsQuery(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      label: "All",
      mobileLabel: "All Collections",
      value: null,
      key: "all"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const allOption = t2;
  let t3;
  if ($[3] !== collections) {
    const collectionOptions = collections.map(_temp);
    t3 = [allOption, ...collectionOptions];
    $[3] = collections;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const items = t3;
  let t4;
  if ($[5] !== items || $[6] !== selected || $[7] !== setSelected) {
    t4 = <CommonDropdown items={items} activeItem={selected} filterLabel="Collection" setSelected={setSelected} />;
    $[5] = items;
    $[6] = selected;
    $[7] = setSelected;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(c) {
  return {
    label: c.collection_name ?? "Unknown Collection",
    value: c.contract,
    key: c.contract
  };
}